import { useQuery } from "@apollo/client";
import { GET_LIST_RESERVATION } from "../graphQl/MyTripsAPI";

export const useReservationList = ({
  paginationParams,
  tripPublicationId,
  ownerId,
  skip = false,
}) => {
  const { data, loading, error, refetch } = useQuery(GET_LIST_RESERVATION, {
    variables: {
      paginationParams,
      tripPublicationId,
      ownerId,
    },
    skip,
    fetchPolicy: "network-only",
  });

  const response = data?.QR_LIST_TRIP_RESERVATION;

  return {
    loading,
    error: response?.error ?? error,
    code: response?.code,
    list: response?.data?.content ?? [],
    totalPages: response?.data?.totalPages,
    totalElements: response?.data?.totalElements,
    currentPage: response?.data?.currentPage,
    refetch,
  };
};

export const getTravelerCount = (reservedPlaces) => {
  return [
    reservedPlaces?.adultPlacesCount,
    reservedPlaces?.childPlacesCount,
    reservedPlaces?.babiesPlacesCount,
  ].reduce((acc, val) => acc + (val ?? 0), 0);
};
